const translations = {
  en: {
    // Navigation
    nav: {
      menu: "Menu",
      socialMedia: "Social Media",
      gallery: "Gallery",
      contactUs: "Contact Us"
    },
    
    // Home page
    home: {
      tagline: "Authentic Vietnamese Noodles",
      orderOnline: "Order Online",
      ourRestaurant: "Our Restaurant",
      footer: "All rights reserved."
    },
    
    // Contact page
    contact: {
      title: "Contact Us",
      senterLocation: "Senter Road Location",
      silverCreekLocation: "Silver Creek Location"
    },
    
    // Info bar
    info: {
      hours: "Mon-Sun: 10:00 AM - 9:00 PM"
    },
    
    // Menu items - you'll need to translate these
    menu: {
      signatureNoodles: "Signature Noodles",
      appetizers: "Appetizers",
      beverages: "Beverages",
      
      // Noodle items
      namVang: {
        name: "Nam Vang",
        description: "Sliced pork, grounded pork, liver, heart, quail egg, shrimp, squid, fried garlic, green onion, cilantro"
      },
      dacBiet: {
        name: "Dac Biet",
        description: "Saigon shrimp & pork (#1) with a bone marrow"
      },
      doBien: {
        name: "Do Bien",
        description: "Shrimp, squid, fried garlic, green onion, cilantro"
      },
      trieuChau: {
        name: "Trieu Chau",
        description: "Shrimp, squid, liver, heart, pork slices, meat ball, fried onion, green onion, cilantro, chives"
      },
      suonNon: {
        name: "Suon Non",
        description: "Pork spareribs, carrot, fried onion, green onion, cilantro, chives"
      },
      suiCao: {
        name: "Sui Cao",
        description: "Shrimp wonton, fried onion, green onion, cilantro, chives"
      },
      hoanhThanh: {
        name: "Hoanh Thanh",
        description: "Wonton, BBQ pork slices, fried onion, green onion, cilantro, chives"
      },
      xaXiu: {
        name: "Xa Xiu",
        description: "BBQ pork slices, fried onion, green onion, cilantro, chives"
      },
      gioHeo: {
        name: "Gio Heo",
        description: "Pork hock, pork slices, fried onion, green onion, cilantro, chives"
      },
      gaXe: {
        name: "Ga Xe",
        description: "Shredded chicken, fried garlic, green onion, cilantro"
      },
      boVien: {
        name: "Bo Vien",
        description: "Beef meatballs, fried onion, green onion, cilantro, chives"
      },
      hoanhThanhLa: {
        name: "Hoanh Thanh La",
        description: "Wonton skin, mini meat ball, dried shrimp, grounded pork, fried onion, green onion, cilantro, chives"
      },
      
      // Appetizers
      xiuMai: {
        name: "Xiu Mai (Meat Ball)",
        description: "Meat ball, cilantro, green onion, fried onion"
      },
      xiQuach4: {
        name: "Xi Quach (4 pcs) (Bone Marrow Soup)",
        description: "Bone marrow (4), cilantro, fried garlic, green onion"
      },
      xiQuach1: {
        name: "Xi Quach (1 pc) (Bone Marrow Soup)",
        description: "Bone marrow (1), cilantro, fried garlic, green onion"
      },
      soupBoVien: {
        name: "Soup Bo Vien (Beef Meatball Soup)",
        description: "Beef meatball, cilantro, fried onion, green onion"
      },
      haCaoChien: {
        name: "Ha Cao Chien (Fried Shrimp Dumplings)",
        description: ""
      },
      suiCaoChien: {
        name: "Sui Cao Chien (Fried Shrimp Wonton)",
        description: ""
      },
      hoanhThanhChien: {
        name: "Hoanh Thanh Chien (Fried Pork Wonton)",
        description: ""
      },
      chaGioChien: {
        name: "Cha Gio Chien (Fried Egg Rolls)",
        description: ""
      },
      banhQuay: {
        name: "Banh Quay (Chinese Donut)",
        description: ""
      },
      
      // Beverages
      cafeSuaDa: {
        name: "Cafe Sua Da (Vietnamese Iced Coffee)",
        description: ""
      },
      bongCuc: {
        name: "Bong Cuc (Herbal Chrysanthemum Tea)",
        description: ""
      },
      miaLao: {
        name: "Mia Lao (Herbal Sugarcane Juice)",
        description: ""
      },
      rongBien: {
        name: "Rong Bien (Herbal Seaweed Drink)",
        description: ""
      },
      sevenUpTacMuoi: {
        name: "7-Up Tac Muoi (Salted Plum 7-Up)",
        description: ""
      },
      traChanh: {
        name: "Tra Chanh (Lemon Iced Tea)",
        description: ""
      },
      mangCauDam: {
        name: "Mang Cau Dam (Mashed Soursop Drink)",
        description: ""
      },
      traiDua: {
        name: "Trai Dua (Fresh Coconut)",
        description: ""
      },
      soda: {
        name: "Soda",
        description: ""
      },
      traNong: {
        name: "Tra Nong (Hot/Iced Tea)",
        description: ""
      },
      traChanhMatOng: {
        name: "Tra Chanh Mat Ong",
        description: "Honey Lemon Tea"
      },
      chanhDayMatOng: {
        name: "Chanh Day Mat Ong",
        description: "Passion Fruit Honey Drink"
      }
    }
  },
  
  vi: {
    // Navigation (Vietnamese)
    nav: {
      menu: "Thực Đơn",
      socialMedia: "Mạng Xã Hội",
      gallery: "Thư Viện",
      contactUs: "Liên Hệ"
    },
    
    // Home page
    home: {
      tagline: "Mì Việt Nam Chính Gốc",
      orderOnline: "Đặt Hàng Trực Tuyến",
      ourRestaurant: "Nhà Hàng Của Chúng Tôi",
      footer: "Đã đăng ký bản quyền."
    },
    
    // Contact page
    contact: {
      title: "Liên Hệ Với Chúng Tôi",
      senterLocation: "Chi Nhánh Senter Road",
      silverCreekLocation: "Chi Nhánh Silver Creek"
    },
    
    // Info bar
    info: {
      hours: "Thứ Hai - Chủ Nhật: 10:00 AM - 9:00 PM"
    },
    
    // Menu items - Vietnamese translations
    menu: {
      signatureNoodles: "Mì Đặc Biệt",
      appetizers: "Khai Vị",
      beverages: "Đồ Uống",
      
      // Noodle items (Vietnamese)
      namVang: {
        name: "Mì Nam Vang",
        description: "Thịt heo thái lát, thịt heo xay, gan, tim, trứng cút, tôm, mực, tỏi phi, hành lá, rau mùi"
      },
      dacBiet: {
        name: "Mì Đặc Biệt",
        description: "Tôm & thịt heo Sài Gòn (#1) với xương tủy"
      },
      doBien: {
        name: "Mì Đồ Biển",
        description: "Tôm, mực, tỏi phi, hành lá, rau mùi"
      },
      trieuChau: {
        name: "Mì Triều Châu",
        description: "Tôm, mực, gan, tim, thịt heo thái lát, thịt viên, hành phi, hành lá, rau mùi, hẹ"
      },
      suonNon: {
        name: "Mì Sườn Non",
        description: "Sườn non heo, cà rốt, hành phi, hành lá, rau mùi, hẹ"
      },
      suiCao: {
        name: "Mì Sui Cao",
        description: "Hoành thánh tôm, hành phi, hành lá, rau mùi, hẹ"
      },
      hoanhThanh: {
        name: "Mì Hoành Thánh",
        description: "Hoành thánh, thịt heo xá xíu, hành phi, hành lá, rau mùi, hẹ"
      },
      xaXiu: {
        name: "Mì Xá Xíu",
        description: "Thịt heo xá xíu, hành phi, hành lá, rau mùi, hẹ"
      },
      gioHeo: {
        name: "Mì Giò Heo",
        description: "Giò heo, thịt heo thái lát, hành phi, hành lá, rau mùi, hẹ"
      },
      gaXe: {
        name: "Mì Gà Xé",
        description: "Gà xé, tỏi phi, hành lá, rau mùi"
      },
      boVien: {
        name: "Mì Bò Viên",
        description: "Bò viên, hành phi, hành lá, rau mùi, hẹ"
      },
      hoanhThanhLa: {
        name: "Mì Hoành Thánh Lạ",
        description: "Vỏ hoành thánh, thịt viên nhỏ, tôm khô, thịt heo xay, hành phi, hành lá, rau mùi, hẹ"
      },
      
      // Appetizers (Vietnamese)
      xiuMai: {
        name: "Xíu Mại",
        description: "Thịt viên, rau mùi, hành lá, hành phi"
      },
      xiQuach4: {
        name: "Xí Quách (4 miếng) (Súp Xương Tủy)",
        description: "Xương tủy (4), rau mùi, tỏi phi, hành lá"
      },
      xiQuach1: {
        name: "Xí Quách (1 miếng) (Súp Xương Tủy)",
        description: "Xương tủy (1), rau mùi, tỏi phi, hành lá"
      },
      soupBoVien: {
        name: "Súp Bò Viên",
        description: "Bò viên, rau mùi, hành phi, hành lá"
      },
      haCaoChien: {
        name: "Há Cảo Chiên",
        description: ""
      },
      suiCaoChien: {
        name: "Sui Cao Chiên",
        description: ""
      },
      hoanhThanhChien: {
        name: "Hoành Thánh Chiên",
        description: ""
      },
      chaGioChien: {
        name: "Chả Giò Chiên",
        description: ""
      },
      banhQuay: {
        name: "Bánh Quẩy",
        description: ""
      },
      
      // Beverages (Vietnamese)
      cafeSuaDa: {
        name: "Cà Phê Sữa Đá",
        description: ""
      },
      bongCuc: {
        name: "Bông Cúc",
        description: ""
      },
      miaLao: {
        name: "Mía Lào",
        description: ""
      },
      rongBien: {
        name: "Rong Biển",
        description: ""
      },
      sevenUpTacMuoi: {
        name: "7-Up Tắc Muối",
        description: ""
      },
      traChanh: {
        name: "Trà Chanh",
        description: ""
      },
      mangCauDam: {
        name: "Mãng Cầu Dầm",
        description: ""
      },
      traiDua: {
        name: "Trái Dừa",
        description: ""
      },
      soda: {
        name: "Soda",
        description: ""
      },
      traNong: {
        name: "Trà Nóng",
        description: ""
      },
      traChanhMatOng: {
        name: "Trà Chanh Mật Ong",
        description: "Trà chanh mật ong"
      },
      chanhDayMatOng: {
        name: "Chanh Dây Mật Ong",
        description: "Chanh dây mật ong"
      }
    }
  }
};

export default translations;